import { SAFETY_REQUIREMENTS_NOTE } from '../types';

import s from './SafetyRequirementsNote.module.scss';

export function SafetyRequirementsNote() {
  return (
    <div className={s.root}>
      <h6 className={s.title}>Checklist of Requirements</h6>
      <p className={s.note}>{SAFETY_REQUIREMENTS_NOTE}</p>
    </div>
  );
}
